'use strict';

var keys = require('stb-keys'),

    Component = require('stb-component');


function AppButton ( config ) {
    var self = this,
        icons = config.application.uris.icons;

    // console.log('appbutton ' + config);
    // console.log(JSON.stringify(config.application));

    // <div class="app-button">
    //     <div class="app-background" style="background-color: #efbe01"></div>
    //     <div class="app-name">Apps</div>
    //     <div class="app-overlay-reflection"></div>
    //     <div class="app-overlay-icon" style="background-image: url('app/img/720/apps.icon.png'); "></div>
    // </div>

    config.events = {
        click: function () {
            console.log(JSON.stringify(config.data));
        },

        keydown: function ( event ) {
            if ( event.code === keys.ok ) {
                config.onClick();
            }
        },

        focus: function () {
            self.$background.className = 'app-background--focus';
            self.$name.className = 'app-name--focus';
            self.$overlay.className = 'app-overlay--focus';
            self.$overlayIcon.className = 'app-overlay-icon--focus';

            if ( icons.shadowActive ) {
                self.$overlay.style.backgroundImage = 'url(' + icons.shadowActive + ')';
            }

            self.$overlayIcon.style.backgroundImage = 'url(' + icons.primeLogoActive + ')';
        },

        blur: function () {
            self.$background.className = 'app-background';
            self.$name.className = 'app-name';
            self.$overlay.className = 'app-overlay';
            self.$overlayIcon.className = 'app-overlay-icon';

            if ( icons.shadowNormal ) {
                self.$overlay.style.backgroundImage = 'url(' + icons.shadowNormal + ')';
            }

            self.$overlayIcon.style.backgroundImage = 'url(' + icons.primeLogoNormal + ')';
        }
    };

    Component.call(self, config);

    self.$body = self.$node.appendChild(document.createElement('div'));
    self.$body.className = 'app-body';

    self.$background = self.$body.appendChild(document.createElement('div'));
    self.$background.className = 'app-background';
    self.$background.style.backgroundColor = config.application.colors.splashBackground;

    self.$name = self.$body.appendChild(document.createElement('div'));
    self.$name.className = 'app-name';
    // self.$name.style.color = config.application.colors.splashFont;
    self.$name.innerText = config.application.name;

    self.$overlay = self.$body.appendChild(document.createElement('div'));
    self.$overlay.className = 'app-overlay';

    if ( icons.shadowNormal ) {
        self.$overlay.style.backgroundImage = 'url(' + icons.shadowNormal + ')';
    }

    self.$overlayIcon = self.$body.appendChild(document.createElement('div'));
    self.$overlayIcon.className = 'app-overlay-icon';
    self.$overlayIcon.style.backgroundImage = 'url(' + icons.primeLogoNormal + ')';
}

// inheritance
AppButton.prototype = Object.create(Component.prototype);
AppButton.prototype.constructor = AppButton;
AppButton.prototype.name = 'app-button';

module.exports = AppButton;
